import React, { useEffect, useRef, useState } from "react";
import { useFetch } from "../../hooks/useFetch";
import { baseURL } from "../../components/utils/utils";
import { useAuthContext } from "../../hooks/useAuthContext";
import styles from "../Pages.module.css";
import tableStyles from "../../components/Table/Table.module.css";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../components/Checkbox/Checkbox";
import SelectObjetos from "../../components/Select/SelectObjetos";
import { delIcon, editIcon } from "../../components/utils/iconsPath";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";

const Registros = () => {
  const navigate = useNavigate();
  const { httpRequest } = useFetch(`${baseURL}/apontamentos/`);
  const { httpGet: httpUsers } = useFetch(`${baseURL}/usuarios/`);
  const { httpGet: httpItens } = useFetch(`${baseURL}/itens/`);
  const { httpGet: httpValor } = useFetch(`${baseURL}/valores/`);
  const { httpGet: httpPagos } = useFetch(`${baseURL}/pagamentos/`);
  const { httpGet: httpClientes } = useFetch(`${baseURL}/clientes/`);

  const cliRef = useRef();
  const datRef = useRef();
  const { user } = useAuthContext();
  const [deleted, setDeleted] = useState(false);

  const [valores, setValorList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [itensList, setItensList] = useState([]);
  const [pagosList, setPagos] = useState([]);
  const [clienteList, setClientes] = useState([]);

  // const [clienteError, setClientError] = useState(false);

  const [fk_UsuId, setUsuId] = useState(0);
  const [CliId, setCliId] = useState(0);
  const [DatIni, setInicio] = useState();
  const [DatFim, setFim] = useState();

  const [filteredItems, setFilteredItems] = useState([]);
  const [showPending, setShowPending] = useState(false);
  const [showPayed, setShowPayed] = useState(false);
  const [showConfirmed, setShowConfirmed] = useState(false);
  const [dadosTabela, setTabela] = useState([]);

  useEffect(() => {
    // console.log("Registro de Horas");
    const getList = async () => {
      if (user && user.token) {
        if (user && user.fk_NivId > 2) {
          setUsuId(user.UsuId);
        }
        const clientes = await httpClientes(user.token, `listar/`);
        setClientes(clientes);
        setInicio(DatIni ? DatIni : getTodayDate(30));
        setFim(DatFim ? DatFim : getTodayDate(0));
        const users = await httpUsers(user.token, `listar/`);
        users && setUsersList(users);
        const itens = await httpItens(user.token, `listar/`);
        itens && setItensList(itens);
        const valores = await httpValor(user.token, `listar/`);
        valores && setValorList(valores);
        const pagos = await httpPagos(user.token, `listarPorApontamento/`);
        pagos && setPagos(pagos);
        const body = { fk_UsuId, CliId, DatIni, DatFim };
        const dados = await httpRequest(body, user.token, "listarPorCliente");

        if (dados && dados) {
          setTabela(dados);
          setFilteredItems(dados);
        }
      } else {
        navigate("/login");
      }

      setDeleted(false);
    };
    getList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleted, fk_UsuId, CliId, DatFim, DatIni]);

  useEffect(() => {
    const filters = [];
    if (showPending) filters.push(1); // Status Pendente
    if (showPayed) filters.push(2); // Status Pago
    if (showConfirmed) filters.push(3); // Status Confirmado

    let result = [...dadosTabela];

    // Filtro por UsuId
    if (fk_UsuId !== 0) {
      result = result.filter((item) => item.fk_UsuId === fk_UsuId);
    }

    // Filtro por status
    if (filters.length > 0) {
      result = result.filter((item) => filters.includes(item.ApoStatus));
    }

    //Filtro por Cliente

    setFilteredItems(Array.isArray(result) ? result : []);
  }, [showPending, showPayed, showConfirmed, fk_UsuId, dadosTabela, deleted]);

  const getTodayDate = (dias) => {
    const mes = dias / 30;
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1 - mes).padStart(2, "0"); // Os meses começam em 0
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleClickdel = async (apontamento) => {
    if (apontamento) {
      const success = await httpRequest(
        apontamento,
        user.token,
        `remover/${apontamento.ApoId}`
      );
      if (success) {
        setDeleted(true);
        setTabela([]);
      }
    }
  };

  const retStatus = (apontamento) => {
    //console.log(apontamento);
    const pago =
      pagosList &&
      pagosList.find((pago) => pago.UsuId === Number(apontamento.ApoId));
    if (apontamento.ApoStatus === 1 && !pago) {
      return "Pendente";
    } else if (apontamento.ApoStatus === 2 && pago) {
      return "Pago";
    } else if (apontamento.ApoStatus === 3 && pago) {
      return "Confirmado";
    } else {
      return "Inconsistente";
    }
  };

  const retUserName = (usuId) => {
    if (usersList.length > 1) {
      const consultor = usersList.find((cons) => cons.UsuId === Number(usuId));
      return consultor.UsuNome;
    }
    return usersList[0].UsuNome;
  };

  const retItemDescricao = (itemId) => {
    if (itensList.length > 1) {
      const item = itensList.find((item) => item.ItemId === Number(itemId));
      console.log(item);
      return item.ItemDes;
    } else {
      console.log(itensList);
      return itensList[0].ItemDes;
    }
  };

  function decimalToHours(decimal) {
    const hours = Math.floor(decimal); // Parte inteira: horas
    const minutes = Math.round((decimal - hours) * 60); // Parte decimal convertida em minutos
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`; // Formatar como hh:mm
  }
  const onClickUpdate = (apontamento) => {
    //const nApontamento = JSON.parse(JSON.stringify(apontamento));
    console.log(apontamento.ApoQtdHoras);

    navigate(`/registrar/${apontamento.fk_ItemId}`, {
      state: { apontamento }
    });
  };

  const retSubTotal = (row) => {
    if (row) {
      const valorHora = retValor(row);
      const valor = valorHora * row.ApoQtdHoras;
      return valor.toFixed(2);
    }
    return 0;
  };
  const retValor = (row) => {
    if (row) {
      const valorHora = valores.find(
        (valor) => valor.ValId === Number(row.fk_ValId)
      );

      return Number(valorHora.ValVal1).toFixed(2);
    }
    return 0;
  };
  const generateReport = () => {
    navigate("/horas", { state: { filteredItems } });
    //console.log(filteredItems);
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  /*******FILTROS********************* */

  const handleSelectUsers = (e) => {
    const selectedId = Number(e.target.value);
    setUsuId(selectedId);
  };

  const handleSelectCliente = async (e) => {
    const selectedId = Number(e.target.value);
    setCliId(selectedId);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Apontamentos realizados</h1>
      <div className={styles.card}>
        <div className={styles.card_filters}>
          <div className={styles.card_filters_item}>
            <SelectObjetos
              label="Usuário"
              id="fk_UsuId"
              options={usersList}
              value={fk_UsuId ? fk_UsuId : 0}
              onChange={(e) => handleSelectUsers(e)}
              valueKey="UsuId"
              labelKey="UsuNome"
              disabled={false}
            />
          </div>
          <div className={styles.card_filters_item}>
            <SelectObjetos
              ref={cliRef} // Referência para o campo Status
              label="Cliente"
              id="CliId"
              options={clienteList}
              value={CliId}
              onChange={(e) => handleSelectCliente(e)}
              valueKey="CliId"
              labelKey="CliNome"
            />
          </div>
        </div>
        <div className={styles.card_filters}>
          <div className={styles.card_filters_item}>
            <Input
              ref={datRef} // Referência para o campo Nome
              label="Data Início"
              id="DatIni"
              type="date"
              value={(DatIni && DatIni) || ""}
              onChange={(e) => setInicio(e.target.value)}
            />
          </div>
          <div className={styles.card_filters_item}>
            <Input
              ref={datRef} // Referência para o campo Nome
              label="Data Fim"
              id="DatFim"
              type="date"
              value={(DatFim && DatFim) || ""}
              onChange={(e) => setFim(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.checkbox_container}>
          <Checkbox
            checked={showPending}
            onChange={(e) => setShowPending(e.target.checked)}
            label="A pagar"
          />
          <Checkbox
            checked={showPayed}
            onChange={(e) => setShowPayed(e.target.checked)}
            label="A confirmar"
          />
          <Checkbox
            checked={showConfirmed}
            onChange={(e) => setShowConfirmed(e.target.checked)}
            label="Pago"
          />
        </div>

        <table className={tableStyles.table}>
          <thead>
            <tr className={tableStyles.tr}>
              <th className={tableStyles.th}>Consultor</th>
              <th className={tableStyles.th}>Tarefa</th>
              <th className={tableStyles.th}>Data</th>
              <th className={tableStyles.th}>Apontado</th>
              <th className={tableStyles.th}>R$ / Hora</th>
              <th className={tableStyles.th}>Valor</th>
              <th className={tableStyles.th}>Status</th>
              <th className={tableStyles.th}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems &&
              filteredItems.map((row) => {
                return (
                  <tr className={tableStyles.tr} key={row.ApoId}>
                    <td className={tableStyles.td}>
                      {retUserName(row.fk_UsuId)}
                    </td>
                    <td className={tableStyles.td}>
                      {retItemDescricao(row.fk_ItemId)}
                    </td>
                    <td className={`${tableStyles.td} ${tableStyles.center}`}>
                      {formatDate(row.ApoData)}
                    </td>
                    <td className={`${tableStyles.td} ${tableStyles.center}`}>
                      {decimalToHours(row.ApoQtdHoras)}
                    </td>
                    <td className={`${tableStyles.td} ${tableStyles.right}`}>
                      {retValor(row)}
                    </td>

                    <td className={`${tableStyles.td} ${tableStyles.right} `}>
                      {retSubTotal(row)}
                    </td>

                    <td className={`${tableStyles.td} ${tableStyles.center}`}>
                      {retStatus(row)}
                    </td>
                    <td className={tableStyles.tdIcon}>
                      <img
                        className={tableStyles.icon}
                        src={editIcon}
                        alt="Editar"
                        title="Editar"
                        onClick={() => onClickUpdate(row)}
                      />
                      <img
                        className={tableStyles.icon}
                        src={delIcon}
                        alt="Excluir"
                        title="Excluir"
                        onClick={() => handleClickdel(row)}
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        <Button
          texto="Gerar Relatório"
          onClick={generateReport}
          active={true}
        />
      </div>
    </div>
  );
};
export default Registros;
